import { Gauge } from 'lucide-react'
import { EmptyState, Section, Table, TableHead, TableHeader, TableRow, TableSkeleton } from '@ideon-api/ideon-ui'
import { useAccountRateLimits } from '../../lib/use-account-rate-limits'
import { AppIdRateLimits } from './AppIdRateLimits'

const TRACKING_NOTE = 'Breach history only exists since tracking began and cannot be recovered for earlier periods.'

export function RateLimitsTab({ applicationIds }: { applicationIds: string[] }) {
  const state = useAccountRateLimits(applicationIds)

  if (applicationIds.length === 0) return <NoProductionIdentifiers />
  if (state.status === 'loading') return <RateLimitsSkeleton />

  return (
    <div className="flex flex-col gap-6">
      <p className="text-ideon-gray-70">{TRACKING_NOTE}</p>
      <p className="text-ideon-gray-70" data-testid="rate-limits-meta">
        {state.meta.appIdCount} app ids, {state.meta.failedCount} failed
      </p>
      {state.rows.map((row) => (
        <AppIdRateLimits key={row.appId} row={row} />
      ))}
    </div>
  )
}

function NoProductionIdentifiers() {
  return (
    <EmptyState
      icon={<Gauge className="h-10 w-10" />}
      heading="No production 3Scale identifiers"
      description="This account has no production 3Scale identifiers, so there are no rate limits to show."
    />
  )
}

// Also stands in while the account loads, so the tab bar does not shift when data lands.
export function RateLimitsSkeleton() {
  return (
    <Section>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Period</TableHead>
            <TableHead>Limit</TableHead>
            <TableHead>Usage</TableHead>
            <TableHead>429 breaches (since tracking began)</TableHead>
          </TableRow>
        </TableHeader>
        <TableSkeleton columns={4} rows={3} />
      </Table>
    </Section>
  )
}
